<template>
    <div style="direction:rtl">
        <CCard>
            <CCardHeader>
                <h3 class="card-title">جابجایی خط</h3>
            </CCardHeader>
            <CCardBody>
                <div style="display:flex;height:65vh;gap:20px">
                    <div style="width:100%;height:65vh;">
                          <CDataTable
                                    :hover="true"
                                    :border="true"
                                    
                                    :striped="true"
                                    :small="true"
                                    :loading="$store.state.InlineLoading.FleetHistory_GetByDate"
                                    :items="$store.state.FleetHistory_GetByDate.RequestResponse"
                                    :fields="fields"
                                    :fixed="true"
                                    :clickableRows="true"
                                    :items-per-page="10"
                                   
                                    pagination
                                    style="overflow: hidden;"
                            >
                                <template #Row="{item,index}">
                                    <td style="direction: ltr">
                                        {{index+1 }}
                                    </td>
                                </template>
                                <template #DateTimeMove="{item,index}">
                                    <td style="direction: ltr">
                                        {{GetDateTime(item.DateTimeMove) }}
                                    </td>
                                </template>
                            </CDataTable>
                    </div>
                    <div style="width:100%;height:65vh;max-width:350px;position: relative;">
                        <div style="width:100%;;position:absolute;top:0;display:flex;flex-direction:column">
                            <CSelect label="نوع فیلتر" style="width:100%;"    :options="FilterOption"  :value.sync="FilterSelect"  @change="ChangeFilter" > </CSelect>
                            <CSelect v-if="FilterSelect!==0" label="خط" style="width:100%;" @change="ChangeFleet"    :options="GetOtions($store.state.Fleets.RequestResponse)"   :value.sync="FleetSelect"   > </CSelect>
                            <CSelect v-if="FilterSelect===2"  label="راننده" style="width:100%;"    :options="GetOtionsDriver($store.state.Drivers.RequestResponse)"  :value.sync="DriverSelect"   > </CSelect>
                            <CSelect v-if="FilterSelect===3" label="خودرو" style="width:100%;"    :options="GetOtionsVehicle($store.state.Vehicles.RequestResponse)"  :value.sync="VehicleSelect"   > </CSelect>
                            
                        </div>
                        <div style="position:absolute;bottom:0;display:flex;flex-direction:column">
                            <label for="stTime" >از:</label> 
                            <date-picker style="width:350px;" v-model="FromDate"  id="stTime"  aria-label="از تاریخ" auto-submit  type="datetime"></date-picker>
                            <label for="stTime" >تا:</label> 
                            <date-picker style="width:350px;" v-model="ToDate"  id="stTime"  aria-label="از تاریخ"  auto-submit  type="datetime"></date-picker>
                                
                                <CButton color="primary" style="float: left;width:100px;height:35px;direction: ltr;margin-left:2%;margin-top: 15px" @click="Update()">
                                    <CIcon name="cil-search"/>&nbsp;به روز رسانی
                                </CButton>
                        </div>
                    </div>
                </div>
            </CCardBody>
            <CCardFooter style="display:flex;direction:ltr;gap:10px;">
                <MPrint 
                        v-if="$store.state.FleetHistory_GetByDate.RequestResponse.length>0"
                        :data="$store.state.FleetHistory_GetByDate.RequestResponse"
                        label="PDF" 
                        title="جابجایی خط"
                        :From="FromDate"
                        :TO="ToDate"
                        :fields="fields">
                </MPrint>
            </CCardFooter>
        </CCard>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        data(){
            return {
                fields:[{"key":"Row","label":"ردیف"},{"key":"VehicleName","label":"کد خودرو"},{"key":"BeforFleetName","label":"خط قدیم"},{"key":"NewFleetName","label":"خط جدید"},{"key":"DriverName","label":"نام راننده"},{"key":"DateTimeMove","label":"تاریخ"}],
                FromDate:'',
                ToDate:'',
                Daterange:[],
                FilterSelect:0,
                FleetSelect:0,
                DriverSelect:0,
                VehicleSelect:0,
                FilterOption:[
                    {value:0,label:'بدون فیلتر'},
                    {value:1,label:'بر اساس خط'},
                    {value:2,label:'بر اساس راننده'},
                    {value:3,label:'بر اساس خودرو'},
                ]
            }
        },
        mounted(){
            var timeNow=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
            var timefrom=Vue.moment().subtract(7,'days').format('YYYY-MM-DD HH:mm:ss');
            this.FromDate=Vue.moment(timefrom, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            this.ToDate=Vue.moment(timeNow, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            this.GetFleets();
            
        },
        methods:{//
            
            GetFleets(){
                this.$store.commit('FleetByUser');
            },
            Driver_GetByFleetID(fleetID){
                this.$store.commit('Driver_GetByFleetID',{
                    FleetID:fleetID
                });
            },
            Vehicle_GetByFleetID(fleetID){
                this.$store.commit('Vehicle_GetByFleetID',{
                    FleetID:fleetID
                });
            },
            GetOtions(fleets){
                var options=[];
                var all={value:-1,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    var option={value:fleet.FleetID,label:fleet.FleetName};
                    options.push(option);
                }
                return options;
            },
            GetOtionsDriver(drivers){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<drivers.length;i++){
                    var driver=drivers[i];
                    var option={value:driver.DriverID,label:driver.Name+' '+driver.FamilyName};
                    options.push(option);
                }
                return options;
            },
            GetOtionsVehicle(vehicles){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<vehicles.length;i++){
                    var vehicle=vehicles[i];
                    var option={value:vehicle.VehicleID,label:vehicle.VehicleName};
                    options.push(option);
                }
                return options;
            },
            ChangeFleet(){
                console.log(this.FilterSelect)
                if(this.FilterSelect===2){
                    this.Driver_GetByFleetID(this.FleetSelect)
                }
                else if(this.FilterSelect===3){
                    this.Vehicle_GetByFleetID(this.FleetSelect)
                }
            },
            ChangeFilter(){
                this.FleetSelect=0;
                this.VehicleSelect=0;
                this.DriverSelect=0;
            },
            Update(){
                if(this.FilterSelect===1){
                    this.FleetHistory_GetByFleet();
                }
                else if(this.FilterSelect===2){
                    this.FleetHistory_GetByDriver();
                }
                else if(this.FilterSelect===3){
                    this.FleetHistory_GetByVehicle();
                } 
                else{
                    this.FleetHistory_GetByDate();
                }
            },
            FleetHistory_GetByDate(){
                var FromDate=Vue.moment(this.FromDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                var ToDate=Vue.moment(this.ToDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                this.$store.commit('FleetHistory_GetByDate',{
                    TS1:FromDate,
                    TS2:ToDate,
                });
            },
            FleetHistory_GetByDriver(){
                var FromDate=Vue.moment(this.FromDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                var ToDate=Vue.moment(this.ToDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                this.$store.commit('FleetHistory_GetByDriver',{
                    TS1:FromDate,
                    TS2:ToDate,
                    DriverID:this.DriverSelect,
                });
            },
            FleetHistory_GetByFleet(){
                var FromDate=Vue.moment(this.FromDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                var ToDate=Vue.moment(this.ToDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                this.$store.commit('FleetHistory_GetByFleet',{
                    TS1:FromDate,
                    TS2:ToDate,
                    FleetID:this.FleetSelect,
                });
            },
            FleetHistory_GetByVehicle(){
                var FromDate=Vue.moment(this.FromDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                var ToDate=Vue.moment(this.ToDate, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                this.$store.commit('FleetHistory_GetByVehicle',{
                    TS1:FromDate,
                    TS2:ToDate,
                    VehicleID:this.VehicleSelect,
                });
            },
            GetDateTime(time){
                return Vue.moment(time, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            },
        }
    }
</script>

<style scoped>

</style>